import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H6 } from '@liveauctioneers/hammer-ui-core/text';
import { useCallback } from 'react';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppDispatch } from '@/redux/hooks';
import { setSearchExclusion } from '@/redux/modules/search/exclusions/searchExclusions.actions';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getPreferencesUrl } from '@/utils/urls';

type Props = {
    onConfirmExclusion: () => void;
    optionId: string | number;
    optionName: string;
};

export const MobileExcludeConfirm = ({ onConfirmExclusion, optionId, optionName }: Props) => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    const handleCancelExclusion = useCallback(() => {
        onConfirmExclusion();
    }, [onConfirmExclusion]);

    const handleConfirmExclusion = useCallback(async () => {
        await dispatch(
            setSearchExclusion({
                exclude: false,
                facetId: 'auctionHouse',
                optionId: Number(optionId),
            })
        );
        onConfirmExclusion();
    }, [dispatch, onConfirmExclusion, optionId]);

    return (
        <div className="my-lg flex flex-col justify-center">
            <div className="mb-lg block">
                {formatMessage(['exclude_house_confirmation'], {
                    values: {
                        link: (
                            <RouteLink
                                className="inline"
                                key="mobile-exclude-confirm-link"
                                to={getPreferencesUrl()}
                            >
                                <FormattedMessage
                                    id="account_settings"
                                    key="mobile-exclude-confirm-link-message"
                                />
                            </RouteLink>
                        ),
                        name: (
                            <H6
                                className="inline"
                                key="mobile-exclude-confirm-name"
                            >
                                {optionName}
                            </H6>
                        ),
                    },
                })}
            </div>

            <div className="flex justify-center space-x-md">
                <Button
                    className="w-[160px]"
                    onClick={handleConfirmExclusion}
                    size="sm"
                >
                    {formatMessage(['confirm'])}
                </Button>
                <Button
                    className="w-[160px]"
                    onClick={handleCancelExclusion}
                    size="sm"
                    variant="outlined"
                >
                    {formatMessage(['cancel'])}
                </Button>
            </div>
        </div>
    );
};
